import { render, staticRenderFns } from "./ProOwnPrice.vue?vue&type=template&id=a4f18a96&scoped=true"
import script from "./ProOwnPrice.vue?vue&type=script&lang=js"
export * from "./ProOwnPrice.vue?vue&type=script&lang=js"
import style0 from "./ProOwnPrice.vue?vue&type=style&index=0&id=a4f18a96&prod&lang=less&scoped=true"
import style1 from "./ProOwnPrice.vue?vue&type=style&index=1&id=a4f18a96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f18a96",
  null
  
)

export default component.exports